var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppPage',{attrs:{"title":"Permissions"}},[_c('Table',{attrs:{"query":_vm.PermissionsQuery,"queryKey":"permissions","headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }